import * as requests from '../api-request'

export const generateLogline = async (data, token) => {
  return requests.toJSON('POST', 'nolan/script_coverage/logline', data, token)
}

export const generateImpression = async (data, token) => {
  return requests.toJSON('POST', 'nolan/script_coverage/impression', data, token)
}

export const generateSynopsis = async (data, token) => {
  return requests.toJSON('POST', 'nolan/script_coverage/synopsis', data, token)
}

export const generateCharacters = async (data, token) => {
  return requests.toJSON('POST', 'nolan/script_coverage/characters', data, token)
}

export const scriptScore = async (data, token) => {
  return requests.toJSON('POST', 'nolan/script_coverage/score', data, token)
}

export const generateComments = async (data, token) => {
  return requests.toJSON('POST', 'nolan/script_coverage/comments', data, token)
}

export const getTimeRange = async (data, token) => {
  return requests.toJSON('POST', 'nolan/script_coverage/time_range', data, token)
}

export const create = async (data = {}, token) => {
  return requests.toJSON('POST', 'script_coverage/create', data, token)
}

export const createResult = async (data = {}, token) => {
  return requests.toJSON('POST', 'script_coverage/results', data, token)
}

export const getList = async (data = {}, token) => {
  // skip store data if there is no token provided
  const queryString = requests.createQueryString(data)
  return requests.toJSON('GET', `script_coverage/list?${queryString}`, { }, token)
}

export const getResults = async (data = {}, token) => {
  // skip store data if there is no token provided
  const queryString = requests.createQueryString(data)
  return requests.toJSON('GET', `script_coverage/results?${queryString}`, { }, token)
}

export const getSingle = async (data = {}, token) => {
  // skip store data if there is no token provided
  const queryString = requests.createQueryString(data)
  return requests.toJSON('GET', `script_coverage/single?${queryString}`, { }, token)
}

export const preview = async (data = {}, token) => {
  return requests.toBlob('POST', 'script_coverage/preview', data, token)
}

export const checkPermission = async (data, token) => {
  return requests.toJSON('POST', 'script_coverage/check_permission', data, token)
}
